import { createGlobalStyle, css } from 'styled-components';
function spaceGenerator() {
    let str = '';
    for (let i = 1; i <= 250; i++) {
        str += `--sp${i}x: calc(var(--spSize) * ${i});`;
    }
    return str;
}
const DefaultVariables = createGlobalStyle `${css `
	:root {
		//! Default Font
		--core_Font: 'CoreFont', sans-serif;

		//! Transition
		--core_trTime: 0.3s;

		//! Spacing
		--spSize: 8px;
		--sp0-5x: calc(var(--spSize) * 0.5);
		--sp1-5x: calc(var(--spSize) * 1.5);
		--sp2-5x: calc(var(--spSize) * 2.5);
		--sp3-5x: calc(var(--spSize) * 3.5);
		--sp4-5x: calc(var(--spSize) * 4.5);
		${spaceGenerator()};

		//! Colors
		--core_white: ${(props) => props.theme.core.colors.core_white};
		--core_black: ${(props) => props.theme.core.colors.core_black};
		--core_gray: ${(props) => props.theme.core.colors.core_gray};
	}
`}`;
export default DefaultVariables;
//# sourceMappingURL=variables.js.map